import { onboarding } from '@services';

export interface ICreateAsset {
  amountProducts: IProductAmount[];
  studioId: string;
  studioName: string;
  user: {
    triggeredBy: string;
    triggeredByAvatar: string;
    triggeredById: string;
    triggeredByEmail: string;
  };
}
export interface IProductAmount {
  productId?: string;
  tempProductName?: string;
  tempProductModel?: string;
  manufacturerId?: string;
  tempManufacturerName?: string;
  resource?: string;
  amount: number;
}

const createAsset = async (data: ICreateAsset): Promise<void> => {
  const path = data.amountProducts[0].productId
    ? '/api/v1/assets/manual/matched'
    : '/api/v1/assets/manual/internal';

  await onboarding.post(path, data);
};

export { createAsset };
